import { ControlData, GivenHeaderData } from 'shell/models/person';
import { AccordionEditDataControl } from 'shell/view-models/edit-data-control';
import { DateTime } from 'luxon';

export const transformEditDataControl = (
  header?: GivenHeaderData,
  controlData?: ControlData
): AccordionEditDataControl | undefined => {
  const result: AccordionEditDataControl | undefined = header
    ? {
        dateValidity: header?.dataDecorrenza ? DateTime.fromISO(header?.dataDecorrenza) : null,
        flag: controlData?.gestioneCF || '0',
        operationIdMunicipality: header?.idOperazioneComune || '',
        senderId: header?.codMittente || '',
        receiverId: header?.codDestinatario || '',
        operation: header?.operazioneRichiesta || '',
        datetimeRequest: header?.dataOraRichiesta || '',
        dateDefinitionFile: header?.dataDefinizionePratica || '',
        applicationSupplier: header?.fornitoreApplicativo || '',
        applicationName: header?.nomeApplicativo || '',
        sendType: header?.tipoInvio || '',
        operationType: header?.tipoOperazione || '',
        applicationVersion: header?.versioneApplicativo || '',
        protocol: header?.protocolloComune || '',
        protocolDate: header?.dataProtocolloComune || '',
        operationIdAnpr: header?.idOperazioneANPR || '',
        operationResult: header?.esitoOperazione || '',
        mutationReason: null,
      }
    : undefined;

  return result;
};
